import BigNumber from "bignumber.js";

export const isNegative = (number: number | string): boolean => {
	const bigNumber = new BigNumber(number);

	return bigNumber.isNegative();
};
